const TRAFFIC_PATH = "/api/v1/traffic/pageview";

export function recordPublicPageView(pathname: string): void {
  if (typeof window === "undefined" || typeof fetch !== "function") {
    return;
  }

  if (!pathname || pathname.startsWith("/founder") || pathname.startsWith("/api")) {
    return;
  }

  void fetch(TRAFFIC_PATH, {
    method: "POST",
    credentials: "same-origin",
    keepalive: true,
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ path: pathname }),
  }).catch(() => {
    // Analytics must never affect the public website.
  });
}
